<template>
  <div class="input-birthday">
    <label class="input-birthdays">
      <input
          type="date"
          :placeholder="$t('form.birthdays')"
          v-model="model"
          @keydown="keydown"
          @change="change"
          :max="maxDate"
          ref="input"
      />
      <span class="val">{{ date }}</span>
    </label>
    <slot></slot>
  </div>
</template>

<script>
import moment from 'moment'
import { getAge } from '@/utils/date'

export default {
  name: 'Birthdays',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: ['value'],
  data: () => ({
    keyPressTime: 0,
  }),
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('change', value)
      },
    },
    date() {
      const date = moment(this.value)
      if (this.value && date.isValid()) {
        return `${date.format('MMMM D, YYYY')} (${this.years} ${this.years > 100 ? 'y.' : 'years'})`
      } else {
        return ''
      }
    },
    years() {
      return getAge(this.value)
    },
    maxDate() {
      return moment().add(-1, 'y').format('YYYY-MM-DD') // 2012-12-22
    },
  },
  methods: {
    change(e) {
      if (e.timeStamp - this.keyPressTime > 1000) {
        this.$refs.input.blur()
      }
    },
    keydown(e) {
      this.keyPressTime = e.timeStamp
    },
  },
}
</script>

<style lang="scss">
.input-birthday {
  display: flex;
  border: 1px solid #DCDDDD;
  border-radius: 10px;
  font-weight: 400;
  font-size: 15px;
  line-height: 125.5%;
  color: #474747;
  background-color: #ffffff;
  outline: none !important;
  width: 100%;
  margin-bottom: 8px;
  input {
    border: none;
    padding: 10px 12px;
  }
}
.input-birthdays {
  position: relative;
  margin-bottom: 0 !important;
  flex: 1 1 0%;

  input {
    color: transparent;
    user-select: none;
    position: relative;
    z-index: 2;
    background: transparent;

    &:focus {
      color: $text;

      & + .val {
        opacity: 0;
      }
    }
  }

  .val {
    position: absolute;
    left: 15px;
    right: 26px;
    line-height: 40px;
    top: 0;
    bottom: 0;
    z-index: 0;
    white-space: nowrap;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  select {
    z-index: 3;
  }
}
</style>
